import React from 'react';
import styled from 'styled-components';
import { Omit } from 'utility-types';

export type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'>;

const StyledButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;

  color: #8f9092;
  transform: scale(1);
  transition: 150ms ease-out all;

  padding: 0 12px;
  font-weight: 900;

  &:hover,
  &:focus {
    transform: scale(1.2);
  }
`;

const MeatballButton = React.forwardRef<HTMLButtonElement, Props>((props, ref) => (
  <StyledButton ref={ref as any} {...props}>
    ⋯
  </StyledButton>
));

export default MeatballButton;
